import { Phone, CalendarCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SITE } from '../data/site';

export default function StickyCallBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-navy-dark/95 backdrop-blur-md md:hidden" data-testid="sticky-call-bar">
      <div className="grid grid-cols-2 gap-2 px-3 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
        <a
          href={SITE.phoneHref}
          data-testid="sticky-mobile-call-button"
          className="flex items-center justify-center gap-2 rounded-full bg-trustgreen py-3 font-display text-sm font-bold text-white"
        >
          <span className="h-2 w-2 rounded-full bg-white animate-pulse-dot" />
          <Phone className="h-4 w-4" /> Call Now
        </a>
        <Link
          to="/contact"
          data-testid="sticky-mobile-schedule-button"
          className="flex items-center justify-center gap-2 rounded-full bg-brand py-3 font-display text-sm font-bold text-white"
        >
          <CalendarCheck className="h-4 w-4" /> Schedule
        </Link>
      </div>
    </div>
  );
}
